import { fetchConfig } from '@theme/utilities';
import { morphSection, sectionRenderer } from '@theme/section-renderer';

/**
 * Kitty Fighter: botón «Switch to 2-Pack» del aviso de envío gratis (snippets/kf-free-shipping.liquid).
 * Cambia en una sola petición el pack de 1 por el de 2 y vuelve a pintar las secciones del carrito
 * igual que cart-items-component (cajón en modo hydration, página del carrito en modo full).
 *
 * data-from / data-to: ids de variante. data-section-id: sección del carrito donde está el botón.
 */
class KfPackSwitch extends HTMLElement {
  connectedCallback() {
    this.querySelector('button')?.addEventListener('click', this.#switchPack);
  }

  disconnectedCallback() {
    this.querySelector('button')?.removeEventListener('click', this.#switchPack);
  }

  #switchPack = async () => {
    const button = this.querySelector('button');
    const { from, to } = this.dataset;
    if (!button || !from || !to) return;

    button.disabled = true;

    /** @type {Map<string, boolean>} id de sección → es cajón */
    const sections = new Map();
    if (this.dataset.sectionId) sections.set(this.dataset.sectionId, true);
    for (const item of document.querySelectorAll('cart-items-component')) {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sections.set(item.dataset.sectionId, item.dataset.drawer !== undefined);
      }
    }

    try {
      for (const sectionId of sections.keys()) sectionRenderer.abortRender(sectionId);

      const body = JSON.stringify({
        updates: { [from]: 0, [to]: 1 },
        sections: Array.from(sections.keys()).join(','),
        sections_url: window.location.pathname,
      });
      const response = await fetch(`${Theme.routes.cart_update_url}`, fetchConfig('json', { body }));
      const cart = await response.json();
      if (!response.ok || cart.errors) throw new Error(cart.description || cart.errors || 'Cart update failed');

      for (const [sectionId, isDrawer] of sections) {
        const html = cart.sections?.[sectionId];
        const mode = isDrawer ? 'hydration' : 'full';
        if (html) {
          await morphSection(sectionId, html, { mode });
        } else {
          await sectionRenderer.renderSection(sectionId, { cache: false, mode });
        }
      }
    } catch (error) {
      console.warn('[kf-pack-switch]', error);
      button.disabled = false;
    }
  };
}

if (!customElements.get('kf-pack-switch')) {
  customElements.define('kf-pack-switch', KfPackSwitch);
}
